<div class="item-container">
  <div class="item-header">
    <h5 class="text-center" *ngIf="!isEdit">{{"COMMON.ADD" | translate}} {{"dress code" | translate}}</h5>
    <h5 class="text-center" *ngIf="isEdit">{{"COMMON.EDIT" | translate}} {{"dress code" | translate}}</h5>
    <div class="edit-icons" (click)="onCancel()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content d-flex flex-column">
    <form action="" [formGroup]="addForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6 mt-3 mt-3 mt-lg-4">
          <label for="">{{"COMMON.ENTER" | translate}} {{"dress code" | translate}}</label>
          <div class="form-input">
            <input type="text" class="form-control" formControlName="dr_c">
          </div>
          <mat-error *ngIf="isControlHasError('dr_c','required')"> {{"COMMON.THR"|translate}}</mat-error>
        </div>
      </div>

      <div>
        <h6 class="pt-3 pt-xl-4 mb-0">{{"COMMON.ITEM" | translate}}</h6>

        <div class="item-c d-flex align-items-center mt-3" *ngFor="let item of selectOptionArrImg; let i = index"
          [ngClass]="{'slide-out': item.slideOut}">

          <div class="drag-img me-3 d-none d-sm-flex flex-column">
            <img src="assets/images/icons/drag_drop.png" class="img-fluid" alt="">
          </div>

          <div class="drop-box m-1" *ngIf="!item.val">
            <!-- Ngx Dropzone for Image Upload -->
            <ngx-dropzone (change)="onSelect($event, i)" class="drop-item" accept="image/jpeg,image/jpg,image/png">
              <ngx-dropzone-label>
                <div class="d-flex flex-column align-items-center">
                  <div class="upload-img mr-2">
                    <img src="assets/images/icons/upload.svg" class="img-fluid">
                  </div>
                  <div>
                    <div>{{"COMMON.CTU" | translate}}</div>
                    <div class="upload-text">{{"COMMON.DD" | translate}}</div>
                  </div>
                </div>
              </ngx-dropzone-label>
            </ngx-dropzone>
          </div>
          <!-- Preview Selected Image -->
          <div class="c-box" *ngIf="item.val">
            <div class="cer-b">
              <div class="cer-i" [style.backgroundImage]="'url('+item.val+')'"></div>
            </div>
          </div>

          <!-- Remove Image -->
          <div class="action-icon ms-3 del-icon" (click)="onDeleteItemImg(i, item.id)">
            <i class="material-icons">delete</i>
          </div>
        </div>

        <!-- <mat-error *ngIf="selectedElement.isOptionErr && isError">{{errorMsg}}</mat-error> -->

        <div class="add-text mt-3 cursor-pointer" (click)="onAddItemImg()">
          <i class="material-icons">add</i> {{"COMMON.ADD" | translate}} {{"COMMON.FIELD" | translate}}
        </div>
      </div>


    </form>
  </div>

  <div class="row">
    <div class="col-md-6 m-auto">
      <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit"
        (click)="onSubmit()">{{"BUTTON.SAVE" | translate }}</button>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>